import { TForm } from "../../../../shared/src/codecs/types/form";

export const foldForm = <T extends TForm<unknown, unknown, unknown>, F>(
    predicate: (form: T) => boolean,
    onLeft: (form: T) => F,
    onRight: (form: T) => F,  
) =>
    (form: T): F => 
        predicate(form) ? onRight(form) : onLeft(form)
;